import { render, staticRenderFns } from "./CNView.vue?vue&type=template&id=0723cd42&scoped=true"
import script from "./CNView.vue?vue&type=script&lang=ts"
export * from "./CNView.vue?vue&type=script&lang=ts"
import style0 from "./CNView.vue?vue&type=style&index=0&id=0723cd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723cd42",
  null
  
)

export default component.exports